<template>
  <div class="swiper-container filmswiper">
    <swiper :options="swiperOption" class="swiper-box" ref="mySwiper">
      <swiper-slide class="slide" v-for="(item,index) in list" :key="index">
        <img class="slide_item"  :src="item.img" alt="" @click="jumpto(index)">
        <!-- <div class="slide_item" :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
      </swiper-slide>
      <!-- <swiper-slide v-for="(item,index) in list" :key="index">
        <img :src="item.img" alt="">
      </swiper-slide>-->
      <div class="my-swiper-pre" slot="button-prev" @click="handelPre">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="my-swiper-next" slot="button-next" @click="handeNext">
        <i class="el-icon-arrow-right"></i>
      </div>
    </swiper>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    }
    // swiperOption:{
    //   type:Object
    // }
  },
  data() {
    return {
      mySwipers:"",
      swiperOption: {
        // 所有的参数同 swiper 官方 api 参数
       loop: this._i18n.locale==='zh'?true:false,
        loopedSlides: 1, // looped slides should be the same
        // spaceBetween: 10,
        // slidePerview:1,
        autoplay:true,
        observer:true
      },
      
    };
  },
  mounted(){
  },
  methods: {
    jumpto(index){
      if(index==1){
        location.href="https://cv.autoguangzhou.com.cn/"
      }else if(index==0){
        // this.$router.push({name:"newsCenter",query:{newsId:34,tab:1}})
        location.href="https://ap.autoguangzhou.com.cn/"
      }
    },
    handelPre() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    handeNext() {
      console.log(this.$refs.mySwiper)
      this.$refs.mySwiper.swiper.slideNext();
    }
  }
};
</script>

<style lang="scss">
.swiper-box {
  // height: 930px;
  width: 100vw;
  .slide {
    // width: 1920px;
    // height: 930px;
    .slide_item {
      width: 100vw;
      // width: 100%;
      // height: 930px;
      background: #fff;
      background-size: cover;
      background-position: center;
    }
  }
  .my-swiper-pre,.my-swiper-next{
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    -moz-background-size: 27px 44px;
    -webkit-background-size: 27px 44px;
    background-size: 27px 44px;
    background-position: center;
    background-repeat: no-repeat;
    font-size: 150px;
    color: #fff;
  }
  .my-swiper-next{
    right: 5%;
  }
}
</style>


// WEBPACK FOOTER //
// mySwiper.vue?db045346